export const ASSIGNED = 'assigned';
export const SELF_ASSIGNED = 'self-assigned';
export const UNASSIGNED = 'unassigned';
export const TEAM_ASSIGNED = 'team-assigned';